export default function decorateUrlWithExtraParameters(url: string, params: string[]) {
  const separator = url.indexOf('?') > 0 ? '&' : '?';
  return `${url}${separator}${params.join('&')}`;
}
